import {
  Button,
  CircularProgress,
  IconButton,
  Slide,
  Snackbar,
  Typography,
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { useContext, useEffect, useRef, useState } from "react"
import { useHistory } from "react-router"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"

import Box from "~/components/Common/Box"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import useReadOnly from "~/hooks/useReadOnly"
import useStyles from "./styles"

function TransitionDown(props) {
  return <Slide {...props} direction="up" />
}

const UnsavedChanges = () => {
  const classes = useStyles()
  const isReadOnly = useReadOnly()

  const blockRef = useRef()

  const [openSaveSnack, setOpenSaveSnack] = useState(false)
  const [openErrorSnack, setOpenErrorSnack] = useState(false)
  const history = useHistory()
  const [transition, setTransition] = useState(undefined)
  const {
    unsavedState,
    loading,
    tryToSave,
    disabledSave,
    updateClientFunc,
    discardChanges,
  } = useContext(ClientContext)
  const { openDialog } = useContext(AppContext)

  //open error snack bar if the user need to complete more data before publish
  useEffect(() => {
    if (disabledSave && tryToSave) {
      setOpenErrorSnack(true)
      setTransition(() => TransitionDown)
    } else if (!disabledSave || !tryToSave) {
      setOpenErrorSnack(false)
    }
  }, [disabledSave, tryToSave])

  //open save snack bar if we have unsaved data
  useEffect(() => {
    if (unsavedState.length > 0) {
      setOpenSaveSnack(true)
      setTransition(() => TransitionDown)
    } else if (unsavedState.length === 0) {
      setOpenSaveSnack(false)
    }
  }, [unsavedState])

  //open dialog if we go to other part of the app without save
  useEffect(() => {
    if (unsavedState.length > 0 && !isReadOnly) {
      blockRef.current = {
        unblock: history.block((tx) => {
          openDialog("unsavedDataDialog", tx).then(() => {
            discardChanges()
            blockRef.current.unblock()
            // tx.retry();
            history.push(tx.pathname)
          })
          return false
        }),
      }
    } else {
      blockRef.current?.unblock?.()
    }
  }, [unsavedState])

  return (
    <PermissionsWrapper permissionGroup="admin">
      <>
        <Snackbar
          open={openSaveSnack}
          classes={{ root: classes.snackBar }}
          message={<Typography variant="subtitle1">Unsaved Changes</Typography>}
          className={classes.snackBar}
          TransitionComponent={transition}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          action={
            <>
              {loading ? (
                <Box display="flex" justifyContent="center" width="100%">
                  <CircularProgress style={{ color: "#fff" }} size={18} />
                </Box>
              ) : (
                <Button
                  color="secondary"
                  size="small"
                  onClick={updateClientFunc}
                >
                  SAVE
                </Button>
              )}
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setOpenSaveSnack(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          }
        />
        <Snackbar
          open={openErrorSnack}
          message={
            <Typography variant="subtitle1">
              Please complete all require inputs.
            </Typography>
          }
          ContentProps={{
            "aria-describedby": "message-id",
            className: classes.snackbarStyleViaContentProps,
          }}
          style={openSaveSnack ? { marginBottom: "80px" } : null}
          classes={{ root: classes.errorSnackBar }}
          TransitionComponent={transition}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          action={
            <>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setOpenErrorSnack(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          }
        />
      </>
    </PermissionsWrapper>
  )
}

export default UnsavedChanges
